import React from "react";
import PropTypes from "prop-types";

import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ErrorSize = {
    Big: "Big",
    Medium: "Medium",
    Small: "Small"
};

const ErrorPanel = (props) => {
    let size = "1x";
    if (props.size === ErrorSize.Big) {
        size = "3x";
    } else if (props.size === ErrorSize.Medium) {
        size = "2x";
    }

    return (
        <div className={"panel text-warning " + props.className}>
            <FontAwesomeIcon icon={faExclamationTriangle} size={size} className="mr-1"/>
            <span>
                {props.children}
            </span>
        </div>
    );
}

ErrorPanel.defaultProps = {
    size: ErrorSize.Big,
    className: ""
}

ErrorPanel.propTypes = {
    size: PropTypes.oneOf(Object.values(ErrorSize)),
    className: PropTypes.string
};

export default (ErrorPanel);